export default "/_next/static/chunks/fonts/Montserrat-SemiBold-latin-44f4c3079c81432c86c97897a6ad5252.woff2";